import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Loader2 } from 'lucide-react';
import client from '../api/client';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setError('No session_id received from Google.');
      return;
    }
    (async () => {
      try {
        await client.post('/auth/google/session', { session_id: sessionId });
        await refresh();
        navigate('/dashboard', { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || e.message);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#FBF7F2] flex flex-col items-center justify-center p-6">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-9 h-9 rounded-full bg-[#7B2C3B] flex items-center justify-center">
          <Heart className="w-4 h-4 text-[#FBF7F2] fill-[#FBF7F2]" />
        </div>
        <span className="font-serif text-2xl font-semibold">
          Yourwedding<span className="italic text-[#7B2C3B]">friends</span>
        </span>
      </div>
      {error ? (
        <div className="soft-card rounded-2xl p-6 max-w-md text-center">
          <p className="text-[#7B2C3B] font-medium mb-2">We couldn’t complete sign-in.</p>
          <p className="text-sm text-[#6A6A6A] mb-4">{error}</p>
          <button className="btn-primary px-5 py-2 rounded-full text-sm" onClick={() => navigate('/auth')}>Try again</button>
        </div>
      ) : (
        <div className="inline-flex items-center gap-2 text-[#6A6A6A]">
          <Loader2 className="w-4 h-4 animate-spin" /> Signing you in…
        </div>
      )}
    </div>
  );
}
